import React from 'react';
import PropTypes from 'prop-types';
import withErrorBoundary from '@/utils/errorBoundary';

import ProtectionCardSkeleton from './ProtectionCardSkeleton';
import ActiveTrialVariant from './variants/ActiveTrialVariant';
import PendingInvoiceVariant from './variants/PendingInvoiceVariant';
import ProPlanVariant from './variants/ProPlanVariant';

const ProtectionCardFactory = ({
  testId,
  isLoading,
  hasInvoice,
  isTrialActive,
  isTrialExpired,
  isAAClient,
  hideButtons,
  hideActivateTrial,
  onActivateProtectionPro,
  onActivateTrial,
  onPendingInvoiceClick,
  isTurbo,
  gatorProtectProPrice,
}) => {
  if (isLoading) {
    return <ProtectionCardSkeleton />;
  }

  if (hasInvoice) {
    return (
      <PendingInvoiceVariant
        testId={testId}
        onPendingInvoiceClick={onPendingInvoiceClick}
      />
    );
  }

  const isTrial = isTrialActive || isTrialExpired;

  if (isTrial) {
    return (
      <ActiveTrialVariant
        testId={testId}
        hideButtons={hideButtons}
        onActivateProtectionPro={onActivateProtectionPro}
      />
    );
  }

  return (
    <ProPlanVariant
      testId={testId}
      hideButtons={hideButtons}
      hideActivateTrial={isTurbo || hideActivateTrial}
      isAAClient={isAAClient}
      onActivateProtectionPro={onActivateProtectionPro}
      onActivateTrial={onActivateTrial}
      gatorProtectProPrice={gatorProtectProPrice}
    />
  );
};

ProtectionCardFactory.propTypes = {
  testId: PropTypes.string,
  isLoading: PropTypes.bool,
  hasInvoice: PropTypes.bool,
  isTrialActive: PropTypes.bool,
  isTrialExpired: PropTypes.bool,
  isAAClient: PropTypes.bool,
  hideButtons: PropTypes.bool,
  hideActivateTrial: PropTypes.bool,
  onActivateProtectionPro: PropTypes.func,
  onActivateTrial: PropTypes.func,
  isTurbo: PropTypes.bool,
  onPendingInvoiceClick: PropTypes.func,
  gatorProtectProPrice: PropTypes.string,
};

ProtectionCardFactory.defaultProps = {
  testId: 'protection-card',
  isLoading: false,
  hasInvoice: false,
  isTrialActive: false,
  isTrialExpired: false,
  isAAClient: false,
  hideButtons: false,
  hideActivateTrial: false,
  onActivateProtectionPro: undefined,
  onActivateTrial: undefined,
  isTurbo: false,
  onPendingInvoiceClick: undefined,
  gatorProtectProPrice: undefined,
};

export default withErrorBoundary(ProtectionCardFactory, 'ProtectionCardFactory');
